import Definition from '@client/config/definition';
import { i18n } from '@client/helper/i18n';

const { t } = i18n;

export const getTabsData = (sportType, sportDataDetailList) => {
  const result = [
    {
      text: t('H4007'),
      key: -1
    }
  ];

  sportDataDetailList.forEach((item, index) => {
    let i18nKey = Definition.getSportI18nKeyBySportType(item.summary.sportType);

    // 登山滑雪-特殊逻辑
    if (['Ski_Touring_Old'].includes(Definition.getSportNameByType(sportType))) {
      i18nKey = {
        // 登山
        Mtn_Climb: 'H4015',
        // 越野滑雪
        XC_Ski: 'H4014'
      }[Definition.getSportNameByType(item.summary.sportType)];
    }

    // 多段攀登-特殊逻辑
    if (['Multi_Pitch'].includes(Definition.getSportNameByType(sportType))) {
      // mutliPitchStage|0-接近 1-攀登 2-下撤|
      i18nKey = {
        // 接近
        0: 'H2027',
        // 攀登
        1: 'H2026',
        // 下撤
        2: 'H2028'
      }[item.summary.mutliPitchStage];
    }

    result.push({
      text: t(i18nKey) || '',
      key: index
    });
  });

  return result;
};
